import { DashboardSections } from "../../_models";

const pdfReportPageHeightPx = 1056;

export const pdfReportPageWidthIn = 8.5;
export const pdfReportPageHeightIn = 11;
export const pdfReportHeaderHeightIn = 1.8;
export const pdfReportFooterHeightIn = 0.51;

const defaultFirstPagePaddingIn = 0.7;
const defaultNextPagePaddingIn = 0.6;
const marketplaceNextPagePaddingIn = 0.8;

const sectionsWithoutFirstPagePadding: DashboardSections[] = [
  DashboardSections.Marketplace,
  DashboardSections.Overview,
  DashboardSections.Return,
  DashboardSections.Order,
  DashboardSections.Subscription,
  DashboardSections.Resolve,
];

export function pdfReportPagePaddingIn(section: DashboardSections, pageIndex: number): number {
  let padding = defaultNextPagePaddingIn;

  if (pageIndex === 0) {
    padding = defaultFirstPagePaddingIn;

    if (sectionsWithoutFirstPagePadding.indexOf(section) !== -1) {
      padding = 0;
    }
  } else if (section === DashboardSections.Marketplace) {
    padding = marketplaceNextPagePaddingIn;
  }

  return padding;
}

export function pdfReportPageCapacityPx(section: DashboardSections, pageIndex: number): number {
  const visibleIn =
    pdfReportPageHeightIn - pdfReportHeaderHeightIn - pdfReportPagePaddingIn(section, pageIndex) - pdfReportFooterHeightIn;

  return Math.floor((visibleIn / pdfReportPageHeightIn) * pdfReportPageHeightPx);
}

export interface PdfReportPageSlice {
  top: number;
  height: number;
}

export function pdfReportPageSlices(container: HTMLElement, section: DashboardSections): PdfReportPageSlice[] {
  const containerTop = container.getBoundingClientRect().top;
  const slices: PdfReportPageSlice[] = [];
  let start = 0;
  let capacity = pdfReportPageCapacityPx(section, 0);

  for (let index = 0; index < container.children.length; index++) {
    const rowBounds = container.children[index].getBoundingClientRect();
    const rowTop = rowBounds.top - containerTop;
    const rowBottom = rowBounds.bottom - containerTop;

    if (rowTop > start && rowBottom - start > capacity) {
      slices.push({ top: start, height: rowTop - start });
      start = rowTop;
      capacity = pdfReportPageCapacityPx(section, slices.length);
    }
  }

  slices.push({ top: start, height: container.scrollHeight - start });

  return slices;
}
